import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  inject,
  observer,
  openViewTransparent
} from '../../../helper/devTools.js'

/* import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css'; */
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    // this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('Rules')
    openViewTransparent(true)
  }
  state = {
    lang: langM.en,
    explainType: 1,
    language:'en'
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    let { type } = this.props.location.query
    this.setState({
      explainType: type
    })
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // try {
    //   this.setState({
    //     uid: uid
    //   })
    //   let getUserInfo = await this.welfareStore.GetUserInfoWeb(uid)
    //   if (getUserInfo && getUserInfo.code == 0) {
    //     this.setState({
    //       userInfo: getUserInfo.res
    //     })
    //   }
    // } catch (error) {
    //   console.error(error)
    //   this.refs.msg.show("error")
    // }
  }


  render() {
    return (
      <div className={`ludo-game-rule-container`}>
        <div className="content" style={{ display: `${this.state.explainType == 1 ? "block" : "none"}` }}>
          <div className="rule-box">
            <span className='rule-title'>{this.state.lang.title}</span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.content }}></span>
            <br />
            {/* <span dangerouslySetInnerHTML={{ __html: this.state.lang.modTitle1 }} className='white'></span>
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.modContent1 }}></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.modTitle2 }} className='white'></span>
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.modContent2 }}></span> */}
            {/* <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.quickTitle }} className='white' ></span>
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.quickContent }}></span>
            <br /> */}
          </div>
          <img className='pic' src="/img/ludo/rule/pic.png" alt="" />
          <div className="rule-box">
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.title2 }} className='rule-title'></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.rule2content }}></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.rule2content2 }}></span>
            <br />
          </div>
        </div>
        <div className="content" style={{ display: `${this.state.explainType == 2 ? "block" : "none"}` }}>
          <div className="rule-box">
            <span className='rule-title' dangerouslySetInnerHTML={{ __html: this.state.lang.props1Title }}></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.props1Conten1 }}></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.props1Conten2 }}></span>
            <br />
          </div>
          <img className='pic' src="/img/ludo/rule/pic3.png" alt="" />

          <div className="rule-box">
            <span className='rule-title' dangerouslySetInnerHTML={{ __html: this.state.lang.props2Title }}></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.props2Conten1 }}></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.props2Conten2 }}></span>
            <br />
            <span dangerouslySetInnerHTML={{ __html: this.state.lang.props2Conten3 }}></span>
            <br />
          </div>
          <img className='pic' src="/img/ludo/rule/pic2.png" alt="" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/ludo/gamerule/index.js